import React from 'react';
import { CommentariesModalPlaceholder } from './CommentariesModalPlaceholder';
import './commentaries_placeholder.scss';
import { ModalScrollableBody } from '../modal';

type Props = {
  isLoading: boolean;
  children: React.ReactNode;
};

export function CommentariesModalLoader({ isLoading, children }: Props) {
  return (
    <ModalScrollableBody>
      {isLoading
        ? new Array(3).fill({}).map((x, index) => (
            <div
              className="commentaries-placeholder__list-item"
              key={index.toString()}
            >
              <CommentariesModalPlaceholder />
            </div>
          ))
        : children}
    </ModalScrollableBody>
  );
}
